// ! Styles

import '../../legend.css';
import '../../main.css';
import '../../main-desktop.css';
import '../../icons.css';

// Bootstrap
import "bootstrap-icons/font/bootstrap-icons.css";
import bootstrapBundleMin from '../../../public/lib/js/bootstrap.bundle.min.js';

// ! Navbar

import {
    closeNavbar,
    attachDropdownListeners
} from '../navbar/navbar';

import '../navbar/navbar';

// ! Queries

import {
    preliminaryFetchTableData
} from '../../queries/fetch-table-data';

// ! Helpers

import {
    createButtonTabs
} from './helpers/create-header';

import {
    createRegionRows
} from '../district/helpers/create-region-rows';

// ! GLOBAL VARIABLES
let tableData;

// ! Handlers

/**
 * Prints the current page
 */
const printBtnHandler = () => {
    window.print();
}

// ! Helpers

const showLoadingUI = () => {
    const loadingSpinner = $(`#loading-spinner-id`);
    loadingSpinner.empty();
    const loadingUI = $(`<div class="loading-spinner-container">` + 
        `<div class="spinner-grow text-primary" role="status">` + 
            `<span class="visually-hidden">Loading...</span>` +
        `</div>` +
    `</div>`);
    loadingSpinner.append(loadingUI);
}

const hideLoadingUI = () => {
    const loadingSpinner = $(`#loading-spinner-id`);
    loadingSpinner.empty();
}

/**
 * Generates the buttons displayed along the top of the table.
 */
const generateHeader = (result) => {
    tableData = result;

    // Generate the date and print buttons
    createButtonTabs(result, printBtnHandler);
    generateTable();
}

/**
 * Generates the table with all the items
 */
const generateTable = () => {
    // Show the loading UI
    const tableContainer = $('#table-container-id');
    tableContainer.empty();


    const newTable = $(`<table class="table ui-table-container-style table-striped"></table>`);

    // Get the current data
    createRegionRows(tableData, 0, newTable);

    tableContainer.append(newTable);
}

$(window).on("load", function() {
    $('#fwv-navbar-id').load("navbar.html", function() {
        attachDropdownListeners();
    });

    // Show the loading UI
    showLoadingUI()

    // Fetch the table data
    preliminaryFetchTableData().then((result) => {
        generateHeader(result);
        hideLoadingUI();
    })
});